<template>
  <v-card flat>
    <v-alert
      v-if="alertMsg.status"
      :timeout="alertMsg.timeout"
      :color="alertMsg.color"
      :type="alertMsg.type"
      dismissible
    >
      {{ alertMsg.text }}
    </v-alert>
    <v-card-text>
      <v-form v-model="valid" ref="busApplicant">
        <v-row>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >Full Name<span style="color: #f00">*</span></label
            >
            <v-text-field
              v-model="editedItem.full_name"
              :rules="validations.firstnameValidations"
              dense
              placeholder="Enter Full Name"
              outlined
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">Gender</label>
            <v-autocomplete
              placeholder="Select Gender"
              :items="genderOptions"
              v-model="editedItem.gender"
              dense
              outlined
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">Date of Birth</label>

            <v-menu
              ref="dobmenu"
              v-model="dobmenu"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
              :offset-x="true"
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editedItem.dob"
                  persistent-hint
                  clearable
                  v-on="on"
                  type="date"
                  dense
                  @change="ValidateAge"
                  :min="minDate"
                  :max="maxDate"
                  outlined
                >
                </v-text-field>
              </template>
            </v-menu>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">country of birth</label>
            <v-autocomplete
              v-model="editedItem.country_code"
              placeholder="select country of birth"
              :items="country_options"
              item-text="name"
              item-value="id"
              outlined
              required
              dense
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >Nationality<span style="color: #f00">*</span></label
            >
            <v-autocomplete
              placeholder="Select Nationality"
              dense
              v-model="editedItem.nationality_code"
              :items="nationality_options"
              :rules="validations.nationalityValidations"
              item-text="name"
              item-value="id"
              outlined
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >Occupation<span style="color: #f00">*</span></label
            >
            <v-autocomplete
              v-model="editedItem.occupation_code"
              :items="occupation_options"
              item-text="name"
              item-value="id"
              :rules="validations.OcupationValidations"
              placeholder="Select Occupation"
              dense
              outlined
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">Address</label>
            <v-text-field
              placeholder="Address"
              outlined
              required
              dense
              v-model="editedItem.address"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
            v-if="validationFields.includes('No of Shares')"
          >
            <label class="ma-0 pa-0"
              >{{ $t("share_holder_percentage")
              }}<span style="color: #f00">*</span></label
            >
            <v-text-field
              :placeholder="$t('share_holder_percentage')"
              v-model="editedItem.no_of_shares"
              suffix="%"
              type="number"
              :rules="validations.sharesRules"
              outlined
              required
              hide-spin-buttons
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("idType") }}<span style="color: #f00">*</span></label
            >
            <v-select
              v-model="editedItem.id_type_code"
              :menu-props="{ bottom: true, offsetY: true }"
              :rules="validations.id_proofrules"
              :items="idtypes_val"
              item-text="name"
              item-value="id"
              outlined
              required
              :placeholder="$t('idtype_select_placeholder')"
              dense
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="6"
            v-if="!isMykad && !NOdatesIdtype.includes(editedItem.id_type_code)"
          >
            <label class="ma-0 pa-0"
              >{{ $t("isuueDate") }}<span style="color: #f00">*</span></label
            >
            <v-text-field
              v-model="editedItem.id_issue_date"
              :rules="validations.issuedaterules"
              dense
              required
              outlined
              type="date"
              :max="currentDate"
            />
          </v-col>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("Location")
              }}<span
                v-if="editedItem.id_type_code === 'Passport'"
                style="color: #f00"
                >*</span
              ></label
            >
            <v-autocomplete
              v-model="editedItem.id_issue_country"
              item-text="name"
              item-value="id"
              :items="country_options"
              :rules="validations.issue_locationRules"
              :placeholder="$t('Location')"
              dense
              outlined
              required
              :min="currentDate"
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
            v-if="!isMykad && !NOdatesIdtype.includes(editedItem.id_type_code)"
          >
            <label class="ma-0 pa-0"
              >{{ $t("expiryDate") }}<span style="color: #f00">*</span></label
            >
            <v-text-field
              v-model="editedItem.id_expiry_date"
              :rules="validations.expDateRules"
              dense
              outlined
              required
              type="date"
              :min="currentDate"
            />
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("idNumber") }}<span style="color: #f00">*</span></label
            >
            <v-text-field
              v-model="editedItem.id_number"
              :rules="validations.id_numberRules"
              :placeholder="$t('id_number_placeholder')"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("IDFirstPage") }}<span style="color: #f00">*</span></label
            >
            <v-file-input
              v-model="editedItem.ID_First_Page"
              :rules="validations.firstpage_rules"
              dense
              accept="image/png, image/jpeg, image/bmp, image/bmp"
              :placeholder="$t('idtype_first_page_placeholder')"
              outlined
              ref="idfirstfile"
              required
              prepend-icon=""
              @change="
                genrateURL(
                  'frontPageUrl',
                  editedItem.ID_First_Page,
                  'ID_First_Page'
                )
              "
            >
              <template v-slot:append>
                <v-icon
                  aria-hidden="false"
                  class="color-primary"
                  @click="openIdfirst"
                >
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="frontPageUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="frontPageUrl"
                  @click="handleImageViewer(frontPageUrl)"
                />
              </template>
            </v-file-input>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">{{ $t("IDLastPage") }}</label>
            <v-file-input
              v-model="editedItem.ID_Last_Page"
              dense
              accept="image/png, image/jpeg, image/bmp, image/bmp"
              :placeholder="$t('idtype_last_page_placeholder')"
              outlined
              ref="idlastfile"
              required
              prepend-icon=""
              @change="
                genrateURL(
                  'backPageUrl',
                  editedItem.ID_Last_Page,
                  'ID_Last_Page'
                )
              "
            >
              <template v-slot:append>
                <v-icon
                  aria-hidden="false"
                  class="color-primary"
                  @click="openIdlast"
                >
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="backPageUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="backPageUrl"
                  @click="handleImageViewer(backPageUrl)"
                />
              </template>
            </v-file-input>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn
        color="primary"
        @click="editedItem.biz_user_id ? update() : onClickNext()"
        >{{ editedItem.biz_user_id ? "Update" : "Save" }}</v-btn
      >
    </v-card-actions>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import { i18n as $ } from "@/locale/index";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { findDatePrevious } from "@/utils/helper";
import { BusUserTypes } from "@/utils/BusDocuments";
import validatemixin from "@/mixins/Busvalidate.mixin";
// import imageViewer from "../tools/imageViewer.vue";
import handleImageUpload from "@/mixins/compressImage.mixin";
import commonService from "@/services/CommonService/commonService.js";
import { isMykadIdType } from "@/utils/isMykadIdType.js";
import businessService from "@/services/BusinessService/businessService.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [validatemixin, handleImageUpload, alerts],
  data: () => ({
    id_type: "",
    dialog: false,
    valid: true,
    NOdatesIdtype:['1','2','9','12','13','7','11'],
    currentDate: new Date().toJSON().split("T")[0],
    buscheckboxes: BusUserTypes(),
    Entitycheckbox: [],
    validationFields: [],
    backPageUrl: null,
    frontPageUrl: null,
    dialogDelete: false,
    dobmenu: false,
    kycStatus: null,
    disableBystatus: null,
    id_type_back: null,
    issue_location: null,
    maxDate: "",
    minDate: "",
    isDobError: false,
    expriydate: false,
    isValidNumber: false,
    country_options: [],
    relation_options: [],
    idtypes: [],
    idtypes_val: [],
    idtype_objs: [],
    nationality_options: [],
    occupation_options: [],
    occupation_objs: [],
    genderOptions: [
      { text: "Male", value: "M" },
      { text: "Female", value: "F" },
    ],
    isSubmitted: false,
    isUploading: false,
    alertMsg: {
      status: false,
      text: "",
      timeout: 2000,
      color: "blue-grey",
      type: "info",
    },
    countrySelected: {},
    headers: [
      {
        text: "Full Name",
        align: "start",
        sortable: false,
        value: "full_name",
      },
      { text: "Type", value: "type" },
      { text: "Email", value: "email_id" },
      { text: "ID type", value: "id_type_code" },
      { text: "ID number", value: "id_number" },
      { text: "First page", value: "first_page" },
      { text: "Last page", value: "last_page" },
      { text: "Actions", value: "actions" },
    ],
    getinformation: [],
    editedIndex: -1,
    biz_user_id: "",
    imageViewerUrl: "",
    isImageViewer: false,
    userId: null,
    editedItem: {
      applicant_type: "Representative",
      full_name: "",
      middle_name: "",
      last_name: "",
      gender: "",
      dob: null,
      email_id: "",
      phone_number: "",
      nationality_code: "",
      occupation_code: "",
      country_code: "",
      // applicant_country_code: "",
      id_type_code: null,
      id_number: null,
      ID_First_Page: null,
      ID_Last_Page: null,
      no_of_shares: null,
      id_issue_date: null,
      id_expiry_date: null,
      id_issue_country: "Malaysia",
      biz_user_id: null,
      address: null,
    },
    deleteId: "",

    validations: {
      emailValidations: [
        (v) => !!v || $.t("emailMsg1"),
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          $.t("emailMsg2"),
      ],
      firstnameValidations: [
        (v) => !!v || $.t("fullname_required"),
        (v) => /^([a-zA-Z]+\s?)*$/.test(v) || $.t("invalid_fullname"),
      ],
      nationalityValidations: [(v) => !!v || $.t("nationalityMsg1")],
      OcupationValidations: [(v) => !!v || "Occupation is required"],
      selfy_rules: [(v) => !!v || $.t("file_select_placeholder")],
      firstpage_rules: [(v) => !!v || $.t("file_select_placeholder")],
      issuedaterules: [(v) => !!v || $.t("issueDateMsg1")],
      issue_locationRules: [],
      expDateRules: [(v) => !!v || $.t("expiryDateMsg1")],
      id_proofrules: [(v) => !!v || $.t("idtypeMsg1")],
      id_numberRules: [(v) => !!v || $.t("idnumberMsg1")],
      interviewData: [(v) => !!v || $.t("interviewDate")],
      interviewTime: [(v) => !!v || $.t("interviewTime")],
    },
  }),
  name: "BasicDetails",
  components: {
    // VuePhoneNumberInput,
    // imageViewer,
  },
  props: {
    selctedEntity: {
      type: String,
    },
  },
  computed: {
    isMykad() {
      return isMykadIdType(this.editedItem.id_type_code, this.idtypes_val);
    },
    ...mapGetters("Transactional", [
      "realtion_list",
      "nationality_list",
      "occupation_list",
    ]),
    ...mapGetters("Authentication", ["country_list"]),
  },

  watch: {
    isMykad(value) {
      if (value) {
        this.editedItem.id_issue_date = null;
        this.editedItem.id_expiry_date = null;
      }
    },
    "editedItem.applicant_type"(applicant_type) {
      console.log("applicant_type", applicant_type);
      this.validationFields = [...this.getRequired(applicant_type)];
      console.log("applicant_type:", this.getRequired(applicant_type));
    },

    "editedItem.id_type"(val) {
      this.idtype_objs.map((i) => {
        if (val === i.parameter_value) {
          this.id_type_code = i.parameter_code;
        }
      });
    },

    id_type(val) {
      this.idtype_objs.map((i) => {
        if (val === i.value) {
          this.id_type_code = i.id;
        }
      });
      if (val == "MYKAD" || val == "MyPR") {
        this.editedItem.id_issue_country = "Malaysia";
        this.disableIssueLoc = true;
      } else {
        // this.user_details.issue_location = "";
        this.disableIssueLoc = false;
      }
      if (val === "Passport") {
        this.validations.issue_locationRules = [
          (v) => !!v || $.t("issue_location_placeholder"),
        ];
      } else {
        this.validations.issue_locationRules = [];
      }
    },

    "editedItem.issue_location"(val) {
      this.country_objs.map((i) => {
        if (val === i.name) {
          this.issue_location_code = i.iso3;
        }
      });
    },

    "editedItem.id_issue_date"(val) {
      if (!val < new Date().toJSON().split("T")[0]) {
        this.validations.issuedaterules.push($.t("issue_date_valid"));
      } else {
        this.validations.issuedaterules = [(v) => !!v || $.t("issueDateMsg1")];
      }
    },
    "editedItem.id_expiry_date"(val) {
      if (!val > new Date().toJSON().split("T")[0]) {
        this.validations.expDateRules.push(
          (v) => !!v || $.t("expiry_date_issue_validate")
        );
      } else {
        this.validations.expDateRules = [(v) => !!v || $.t("expiryDateMsg1")];
      }
    },

    countrySelected(newVal) {
      console.log("Selected country", newVal);
      if (Object.keys(newVal).length > 0) {
        this.editedItem.country_code = newVal.name;
        this.editedItem.applicant_country_code = newVal.iso3;
      }
    },
  },

  mounted() {
    this.getOccupation();
    this.getNationalityList();
    this.getidtypes();
    if (this.$route.query.customer_id) {
      this.getapplicant();
    }
    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
  },

  methods: {
    genrateURL(keyField, value, assignKey) {
      if (!keyField) return;

      if (!value) {
        if (assignKey == "ID_First_Page") {
          this.frontPageUrl = null;
        } else if (assignKey === "ID_Last_Page") {
          this.backPageUrl = null;
        }
        this.editedItem[`${assignKey}`] = null;
      } else {
        if (assignKey == "ID_First_Page") {
          this.frontPageUrl = URL.createObjectURL(value);
        } else if (assignKey === "ID_Last_Page") {
          this.backPageUrl = URL.createObjectURL(value);
        }
        this.editedItem[`${assignKey}`] = value;
      }
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },

    async getapplicant() {
      this.isLoading = true;
      try {
        const response = await businessService.getApplicantInfo({
          customer_id: this.$route.query.customer_id,
        });
        if (response && response.data.status_code == 200) {
          this.isLoading = false;
          if (response.data.data[0]) {
            const applicant_data = response.data.data[0];
            this.editedItem = {
              applicant_type: "Representative",
              full_name: applicant_data.full_name,
              middle_name: "",
              last_name: "",
              gender: applicant_data.gender,
              dob: applicant_data.dob,
              address: applicant_data.address,
              email_id: applicant_data.email_id,
              phone_number: applicant_data.phone_number,
              nationality_code: applicant_data.nationality?.iso_alpha3 ?? "",
              occupation_code: applicant_data.occupation?.value_code ?? null,
              country_code: applicant_data.country?.iso_alpha3 ?? null,
              // applicant_country_code: "",
              id_type_code: applicant_data?.id_type.value_code ?? null,
              id_number: applicant_data.id_number,
              ID_First_Page: applicant_data.id_first_page
                ? {
                    name: applicant_data.id_first_page?.split("/").pop(),
                    value: applicant_data.id_first_page,
                  }
                : null,
              ID_Last_Page: applicant_data.id_last_page
                ? {
                    name: applicant_data.id_last_page?.split("/").pop(),
                    value: applicant_data.id_last_page,
                  }
                : null,
              no_of_shares: null,
              id_issue_date: applicant_data.id_issue_date,
              id_expiry_date: applicant_data.id_expiry_date,
              id_issue_country: applicant_data.id_issue_country,
              biz_user_id: applicant_data.biz_user_id,
            };
            this.backPageUrl = applicant_data.id_last_page
              ? applicant_data.id_last_page
              : null;
            this.frontPageUrl = applicant_data.id_first_page
              ? applicant_data.id_first_page
              : null;
          }
        } else {
          this.loader = false;
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
    },

    async getOccupation() {
      try {
        const responseData = await commonService.getparameterdropdowns("OCC");
        if (responseData.data.status_code === 200) {
          this.occupation_options = responseData.data.data.map((i) => {
            this.occupation_objs.push(i);
            return {
              name: i.value,
              id: i.value_code,
            };
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async fileUpload(fileObject, biz_user_id, doc_type) {
      this.loader = true;
      let compressdata = await this.handleImageUpload(fileObject);
      console.log(compressdata);
      let fileData = new FormData();
      fileData.append("document", compressdata);
      try {
        const responseData = await businessService.UploadApplicantFiles(
          fileData,
          {
            customer_id: this.$route.query.customer_id,
            biz_user_id: biz_user_id,
            doc_type: doc_type,
          }
        );

        if (responseData && responseData.data.status_code == 200) {
          console.log("responseData", responseData);
          this.loader = false;
          this.getapplicant();
        } else {
          this.loader = false;
        }
      } catch (error) {
        this.loader = false;
        console.log(error);
      }
    },
    async getidtypes() {
      try {
        const responseData = await commonService.getparameterdropdowns("DOC");
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((idtype) => {
            this.idtypes.push(idtype.value);
            this.idtypes_val.push({
              name: idtype.value,
              id: idtype.value_code,
            });
            this.idtype_objs.push(idtype);
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    openIdlast() {
      this.$refs.idlastfile.$el.querySelector("input").click();
    },
    openIdfirst() {
      this.$refs.idfirstfile.$el.querySelector("input").click();
    },
    ValidateAge(value) {
      if (!value) this.isDobError = false;
      else this.isDobError = !(value <= this.maxDate && value >= this.minDate);
    },
    onChangeNumber(e) {
      this.isValidNumber = e.isValid;
    },

    async getNationalityList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((i) => {
            this.country_options.push({
              name: i.country_name,
              id: i.iso_alpha3,
            });
            this.nationality_options.push({
              name: i.nationality,
              id: i.iso_alpha3,
            });
          });
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    editItem(item) {
      this.editedIndex = this.getinformation.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.applicant_type = item.type;
      console.log("image data", item.type);
      this.idtype_objs.map((ele) => {
        console.log("ele", ele);
        if (ele.value == item.id_type_code) {
          this.editedItem.id_type_code = ele.value_code;
        }
      });
      this.editedItem.ID_First_Page = item.first_page
        ? {
            name: item.first_page?.split("/").pop(),
            value: item.first_page,
          }
        : null;

      this.editedItem.ID_Last_Page = item.last_page
        ? {
            name: item.last_page?.split("/").pop(),
            value: item.last_page,
          }
        : null;
      this.backPageUrl = item.last_page ? item.last_page : null;
      this.frontPageUrl = item.first_page ? item.first_page : null;
      this.editedItem.occupation_code = item.occupation_code
        ? item.occupation_code
        : null;
      // this.getapplicant();
      this.dialog = true;
    },

    onClickNext() {
      console.log(`editedItem: ${JSON.stringify(this.editedItem)}`);
      if (this.$refs.busApplicant.validate()) {
        this.save();
      }
    },

    onClickBack() {
      this.$emit("onClickBack");
    },

    async save() {
      this.loader = true;
      if (this.editedIndex > -1) {
        Object.assign(this.getinformation[this.editedIndex], this.editedItem);
      }
      try {
        const responseData = await businessService.addApplicantInfo(
          this.editedItem,
          {
            customer_id: this.$route.query.customer_id,
          }
        );

        if (
          responseData &&
          responseData.data &&
          responseData.data.success === true
        ) {
          this.userId = responseData.data.data[0].biz_user_id;
          console.log(" this.userId", this.userId);
          this.loader = false;
          console.log("ll", responseData);
          this.showAlertSuccess(responseData.data.message);
          this.fileUpload(
            this.editedItem.ID_First_Page,
            responseData.data.data[0].biz_user_id,
            "ID_First_Page"
          );
          this.fileUpload(
            this.editedItem.ID_Last_Page,
            responseData.data.data[0].biz_user_id,
            "ID_Last_Page"
          );
          this.getapplicant();
        } else {
          this.loader = false;
          this.showAlertError(`Creation Failed: ${responseData.data.message}`);
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
      }
    },

    update() {
      if (this.$refs.busApplicant.validate()) {
        this.updateData();
      }
    },

    async updateData() {
      this.loader = true;
      try {
        const responseData = await businessService.updateApplicantInfo(
          this.editedItem,
          {
            customer_id: this.$route.query.customer_id,
            biz_user_id: this.editedItem.biz_user_id,
          }
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.fileUpload(
            this.editedItem.ID_First_Page,
            responseData.data.data[0].biz_user_id,
            "ID_First_Page"
          );
          this.fileUpload(
            this.editedItem.ID_Last_Page,
            responseData.data.data[0].biz_user_id,
            "ID_Last_Page"
          );

          this.getapplicant();
          this.loader = false;
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
    },
  },
};
</script>
<style>
.v-input .v-label {
  margin-bottom: 0px !important;
}
</style>
